
export const PK_LIST = (state) => state.pkList;

export const CONFIRM_PK_LIST = (state) => state.confirm_PK_list;

export const GET_PK_CODE = (state) => state.PK_CODE;

export const SET_SAVE_PANENAME = (state) => state.SAVE_PANENAME;
export const SET_SAVE_STOCKLIST = (state) => state.SAVE_STOCKLIST;
// ------------------------------------------采买单
export const SET_PURCHASE_SEARCH = (state) => state.PURCHASE_SEARCH;
// ---------------分菜单管理
export const SET_SORT_SEARCH = (state) => state.SET_SORT_SEARCH;
// ----------在用SKU管理
export const SET_SKU_USED_DATA_CONDITION = (state) => state.SET_SKU_USED_DATA_CONDITION;
// 分拣配送-分拣组管理
export const SET_SORTING_GROUP_MANAGEMENT_CONDITION = (state) => state.SET_SORTING_GROUP_MANAGEMENT_CONDITION;
export const isAddBtnToProduct = (state) => state.isAddBtnToProduct;
export const hasUnreadInformation = (state) => Boolean(state.UNREAD_INFORMATION_LIST.filter(({ STATUS }) => [2].includes(STATUS)).length);
export const hasUnfinishedInformation = (state) => Boolean(state.UNREAD_INFORMATION_LIST.filter(({ STATUS }) => [1, 3].includes(STATUS)).length);

export const appointmentIntervalID = (state) => Number(state.APPOINTMENT_INTERVAL_ID);



//////////////////
// WEBPACK FOOTER
// ./store/getter.js
// module id = null
// module chunks = 